// extracted by mini-css-extract-plugin
export var footer = "_qm-0";
export var inherit = "_qm-1";
export var input = "_qm-2";
export var modalContent = "_qm-3";
export var quillEditor = "_qm-4";
export var subtitle = "_qm-5";